import i18n from 'i18next';

import { CompanyOrigin, SubscriptionPlans } from '../../../dataStore';

export const originEnumToString = (companyOrigin: CompanyOrigin) => {
  const originMap = {
    [CompanyOrigin.Harmony]: i18n.t('newnity.company.origin.harmony'),
    [CompanyOrigin.MagentoSmbUsa]: i18n.t('newnity.company.origin.magentoSmbUsa'),
  };

  return originMap[companyOrigin];
};

export const getAvailableSubs = (
  companyOrigin: CompanyOrigin
): { label: string; value: SubscriptionPlans }[] => {
  const originMap = {
    [CompanyOrigin.Harmony]: [
      {
        label: i18n.t('newnity.company.subscriptionPlan.custom'),
        value: SubscriptionPlans.Custom,
      },
    ],
    [CompanyOrigin.MagentoSmbUsa]: [
      {
        label: i18n.t('newnity.company.subscriptionPlan.starter'),
        value: SubscriptionPlans.Starter,
      },
      {
        label: i18n.t('newnity.company.subscriptionPlan.intermediate'),
        value: SubscriptionPlans.Intermediate,
      },
      {
        label: i18n.t('newnity.company.subscriptionPlan.advanced'),
        value: SubscriptionPlans.Advanced,
      },
    ],
  };

  return originMap[companyOrigin];
};
